<template>
  <div class="sp-template">
    <div class="h-title">费用补录</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="110px">
          <el-row>
            <el-form-item label="分摊类型">
              <el-select v-model="queryForm.shareType" filterable clearable multiple placeholder="选择分摊类型">
                <el-option v-for="(d, i) in shareTypeData" :key="i" :label="d.name" :value="d.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
              <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            </el-form-item>
          </el-row>
          <el-row>
            <!-- <el-form-item label="仓库">
              <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="订单号/批次号">
              <el-input type="textarea" v-model="orderIds" placeholder="多个号用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(41102)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button v-if="in_configs(41102)" size="small" @click="reset()">清 空</el-button>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryForm.audit" @tab-click="searchTask">
          <el-tab-pane label="未审核" name="未审核"></el-tab-pane>
          <el-tab-pane label="审核通过" name="审核通过"></el-tab-pane>
          <el-tab-pane label="未通过" name="未通过"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button v-if="in_configs(41101)" size="small" @click="handleAdd">新建</el-button>
          <el-button v-if="in_configs(41106)" size="small" @click="showAddDoalog">批量导入</el-button>
          <el-button v-if="in_configs(41107) && queryForm.audit=='未审核'" :disabled="disabledAuditBtn" size="small" @click="auditSupelement('AUDIT_NOT_PASSED')">审核不通过</el-button>
          <el-button v-if="in_configs(41107) && queryForm.audit=='未审核'" :disabled="disabledAuditBtn" size="small" @click="auditSupelement('AUDIT_PASSED')">审核通过</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="supplementData" stripe border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="number" label="订单号/批次号"></el-table-column>
        <el-table-column label="仓库">
          <template slot-scope="scope">
            {{warehouseMap[scope.row.warehouseCode]}}
          </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column prop="chargeSubject" label="费用科目"></el-table-column>
        <el-table-column prop="shareType" label="分摊类型"></el-table-column>
        <el-table-column prop="chargeType" label="费用分类"></el-table-column>
        <el-table-column label="供应商">
          <template slot-scope="scope">
            {{supplierMap[scope.row.supplierId]}}
          </template>
        </el-table-column>
        <el-table-column prop="supplementType" label="补录类型"></el-table-column>
        <el-table-column prop="amount" label="金额"></el-table-column>
        <el-table-column prop="currency" label="币种"></el-table-column>
        <el-table-column prop="operator" label="操作人"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="auditName" label="审核状态"> </el-table-column>
        <el-table-column prop="createAt" label="操作时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-show="in_configs(41107) && queryForm.audit=='未审核'"  @click="handleEdit(scope.$index, scope.row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

    </el-card>
    <!-- 批量导入 -->
    <el-dialog title="批量补录费用" :visible.sync="dialogFormVisible" width="450px">
      <el-form size="small" label-width="80px" label-position="left">
        <el-form-item label="下载模板">
          <a :href="downloadTemp" download="ExpenseRecordTemplate.xlsx">
            <el-button size="small" type="text">点击下载</el-button>
          </a>
        </el-form-item>
        <el-form-item label="上传文件">
          <el-upload action="#" name="upload" :limit="1" list-type="text" accept=".xlsx,.xls" :on-change="handlePictureCardChange" :on-remove="handleRemove" :auto-upload="false" :file-list="fileList">
            <el-button slot="trigger" size="mini">选取文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="upload">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog title="费用审核" :visible.sync="auditFormVisible" width="30%">
      <el-button size="small" @click="auditFormVisible = false">取 消</el-button>
      <el-button size="small" type="danger" @click="auditSupelement('AUDIT_NOT_PASSED')">不通过</el-button>
      <el-button size="small" type="primary" @click="auditSupelement('AUDIT_PASSED')">审核通过</el-button>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderIds: "",
      queryForm: {
        warehouseIds: [],
        audit: "未审核",
        orderIds: [],
        shareType: [],
        startDate: "",
        endDate: "",
        export: 0
      },
      supplementData: [],
      customers: [],
      customerMaps: {},
      shareTypeData: [],
      shareTypeDataMaps: {},
      dialogVisible: false,
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1, //当前页

      warehouses: [],
      warehouseMap: {},

      dialogFormVisible: false,
      formLabelWidth: "120px",
      downloadTemp: "../../../static/template/price/expenseRecordTemplate.xlsx",
      fileList: [],
      auditIds: [],
      auditFormVisible: false,
      multipleSelection: [],
      disabledAuditBtn: true,
      supplierMap: {}
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.initData();
    }, 1000);
  },
  computed: {},
  methods: {
    searchTask() {
      this.currentPage = 1;
      this.query();
    },
    reset() {
      this.orderIds = "";
      this.queryForm = {
        warehouseIds: [],
        audit: "未审核",
        orderIds: [],
        shareType: [],
        startDate: "",
        endDate: "",
        export: 0
      };
      this.searchTask();
    },
    initData() {
      let _this = this;
      let urlArray = [
        this.findAllCustomerName(),
        this.findAllShareType(),
        this.findAllWarehouse()
      ]; // unknown # of urls (1 or more)

      this.$axios.all(urlArray).then(
        this.$axios.spread(function(
          customerData,
          shareTypeData,
          warehouseData
        ) {
          _this.initCustomerData(customerData);
          _this.initShareType(shareTypeData);
          _this.initWarehouseData(warehouseData);
          _this.query();
        })
      );

      this.querySupplier();
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
      _this.warehouses.forEach(a => {
        _this.warehouseMap[a.id] = a.name;
      });
    },
    initShareType(data) {
      let _this = this;
      _this.shareTypeData = data.data;
      if (_this.shareTypeData.length > 0) {
        _this.shareTypeData.forEach(c => {
          _this.shareTypeDataMaps[c.code] = c.name;
        });
      }
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
        {
          withCredentials: true
        }
      );
    },
    findAllShareType() {
      return this.$request1.get(
        '/supplement/share-type',
        {
          withCredentials: true
        }
      );
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll',
        {
          withCredentials: true
        }
      );
    },
    // 初始化查询方法
    query() {
      let _this = this;
      let _audit = "NOT_AUDITED";
      if (_this.queryForm.audit == "未通过") {
        _audit = "AUDIT_NOT_PASSED";
      } else if (_this.queryForm.audit == "审核通过") {
        _audit = "AUDIT_PASSED";
      }
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }

      //过滤仓库
      // let wlist = [];
      // if(this.warehouses!=null && this.warehouses.length>0){
      //     if(_this.queryForm.warehouseIds && _this.queryForm.warehouseIds.length>0){
      //         wlist = _this.queryForm.warehouseIds;
      //     }else{
      //         wlist = this.warehouses.map(a => a.id);
      //     }
      // }else{
      //     wlist.push("NOT MATCHING");
      // }

      this.$request1({
        method: 'post',
        url: '/supplement/query',
        data: {
          numbers: this.queryForm.orderIds,
          shareType: this.queryForm.shareType,
          startDate: this.queryForm.startDate,
          endDate: this.queryForm.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          export: this.queryForm.export,
          audit: _audit
          //warehouseIds: wlist
        }
      })
        .then(response => {
          if (response.data.success) {
            this.total = response.data.total;
            this.supplementData = response.data.data;
          } else {
            _this.$message.error(response.data.message);
            this.supplementData = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleAdd(index, row) {
      !row && this.$router.push("/orderOperation/newcostback");
      row &&
        this.$router.push({
          path: "/orderOperation/newcostback",
          query: { data: row, ishandler: true }
        });
    },

    //搜索
    searchSubject() {
      this.currentPage = 1;
      this.query();
    },
    showAddDoalog() {
      this.dialogFormVisible = true;
      this.fileList = [];
    },
    upload() {
      let _this = this;
      if (!_this.fileList || _this.fileList.length == 0) {
        _this.$message.error("请选择模板文件");
        return false;
      }
      let formData = new FormData();
      formData.append("template", _this.fileList[0].raw);
      this.$confirm("确定批量导入费用？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        _this.$request1
          .post(
            '/supplement/upload',
            formData,
            {
              withCredentials: true
            }
          )
          .then(response => {
            if (response.data.success) {
              this.dialogFormVisible = false;
              this.$notify.success({
                title: "批量补录费用成功:",
                message: response.data.message
              });
              this.searchTask();
            } else {
              this.$notify.error({
                title: "批量补录费用失败,异常提示:",
                message: response.data.message,
                duration: 0
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    handleEdit(index, row) {
      let _this = this;
      if (row.audit === false || row.audit === true) {
        _this.$message({
          message: "不可重复审核",
          type: "error",
          center: true,
          duration: 1500
        });
        false;
      } else {
        let _ids = new Array();
        _ids.push(row.id);
        _this.auditIds = [];
        _this.auditIds = _ids;
        _this.auditFormVisible = true;
      }
    },
    auditSupelement(audit) {
      let _this = this;
      this.$confirm(
        "请仔细核对，操作后无法修改!您确定要审核这" +
          _this.auditIds.length +
          "条费用科目吗？",
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$request1({
            method: 'post',
            url: '/supplement/audit',
            data: { ids: _this.auditIds, audit: audit }
          })
            .then(res => {
              if (res.data.success) {
                this.query();
                this.$message({
                  message: "审核成功",
                  type: "success",
                  center: true,
                });
                _this.auditFormVisible = false;
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error",
                  center: true,
                });
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消审核操作"
          });
        });
    },

    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },
    handlePictureCardChange(file, fileList) {
      //console.log(file, fileList);
      this.fileList.push(file);
    },
    handleRemove(file, fileList) {
      //console.log(file, fileList);
      this.fileList = [];
    },
    //多选按钮
    handleSelectionChange(val) {
      let _this = this;
      this.multipleSelection = val;
      this.disabledAuditBtn = true;
      _this.auditIds = [];
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        let _ids = new Array();
        this.multipleSelection.forEach((d, i) => {
          this.disabledAuditBtn = false;
          _ids.push(d.id);
        });
        _this.auditIds = _ids;
      }
    },
    // 供应商名称
    querySupplier() {
      this.$request1({
        method: 'GET',
        url: '/supplier'
      })
        .then(response => {
          let suppliers = response.data;
          if (suppliers != null && suppliers.length > 0) {
            suppliers.forEach(item => {
              this.supplierMap[item.id] = item.name;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
.txt_success {
  color: green;
}
.txt_failed {
  color: red;
}
.el-card .el-card__header .el-form.header-search__form .search-form__buttons {
  padding-left: 110px;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/chargesupplement.vue